'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.BalanceMixin = exports.roundDownFormatter = exports.compactFormatter = void 0;
var tslib_1 = require("tslib");
var vue_property_decorator_1 = require("vue-property-decorator");
var magic_messages_1 = require("@gig/magic-messages");
var util_1 = require("../util");
var bus_1 = require("../bus");
var services_1 = require("../services");
var options = {
    notation: 'compact',
    roundingMode: 'floor',
    minimumFractionDigits: 0,
    maximumFractionDigits: 1,
};
exports.compactFormatter = Intl.NumberFormat('en', options);
exports.roundDownFormatter = Intl.NumberFormat('en', {
    // @ts-ignore
    roundingMode: 'halfEven',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});
var BalanceMixin = /** @class */ (function (_super) {
    tslib_1.__extends(BalanceMixin, _super);
    function BalanceMixin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.queriedCurrency = null;
        _this.isTooltipOpen = false;
        _this.isTopNavEnabled = true;
        _this.deviceSubscription = null;
        _this.landscapeSubscription = null;
        return _this;
    }
    BalanceMixin.prototype.created = function () {
        var _a, _b;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _c, _d, _e;
            var _this = this;
            return tslib_1.__generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        _c = this;
                        return [4 /*yield*/, window.queryBus.query(magic_messages_1.BALANCE_CURRENCY_QUERY)];
                    case 1:
                        _c.queriedCurrency = (_f.sent());
                        _d = this;
                        return [4 /*yield*/, bus_1.configQuery('topNavBalanceCompactLimit')];
                    case 2:
                        _d.topNavBalanceCompactLimit =
                            (_a = (_f.sent())) !== null && _a !== void 0 ? _a : 10000;
                        _e = this;
                        return [4 /*yield*/, bus_1.configQuery('sideNavBalanceCompactLimit')];
                    case 3:
                        _e.sideNavBalanceCompactLimit =
                            (_b = (_f.sent())) !== null && _b !== void 0 ? _b : 100000;
                        this.deviceSubscription = bus_1.deviceChange(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var cssDevice, isTopNavigationEnabled;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, window.queryBus.query(magic_messages_1.BREAKPOINT_DEVICE_QUERY)];
                                    case 1:
                                        cssDevice = _a.sent();
                                        return [4 /*yield*/, services_1.getFeatureEnabled(magic_messages_1.Feature.TOP_NAVIGATION)];
                                    case 2:
                                        isTopNavigationEnabled = _a.sent();
                                        this.isMobile = cssDevice === util_1.CssDevice.MOBILE;
                                        this.isDesktop =
                                            !isTopNavigationEnabled &&
                                                (cssDevice === util_1.CssDevice.DESKTOP ||
                                                    cssDevice === util_1.CssDevice.LARGE);
                                        this.isTooltipOpen = false;
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        this.landscapeSubscription = window.eventBus.subscribe(magic_messages_1.BREAKPOINT_LANDSCAPE_UPDATED, function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var _a;
                            return tslib_1.__generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        _a = this;
                                        return [4 /*yield*/, window.queryBus.query(magic_messages_1.BREAKPOINT_LANDSCAPE_QUERY)];
                                    case 1:
                                        _a.isLandscape = _b.sent();
                                        this.isTooltipOpen = false;
                                        return [2 /*return*/];
                                }
                            });
                        }); }, { replay: true });
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(BalanceMixin.prototype, "desktopView", {
        get: function () {
            return this.isDesktop && !this.gameplay;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BalanceMixin.prototype, "landscapeGameplay", {
        get: function () {
            return this.isLandscape && this.gameplay;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BalanceMixin.prototype, "landscapeView", {
        get: function () {
            return !this.fullscreen && !this.isDesktop && this.landscapeGameplay;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BalanceMixin.prototype, "largeButton", {
        get: function () {
            return !this.landscapeGameplay && this.isDesktop && !this.fullscreen;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BalanceMixin.prototype, "wideButton", {
        get: function () {
            return this.landscapeGameplay || this.isDesktop;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BalanceMixin.prototype, "formatLimit", {
        get: function () {
            return this.isTopNavEnabled
                ? this.topNavBalanceCompactLimit
                : this.sideNavBalanceCompactLimit;
        },
        enumerable: false,
        configurable: true
    });
    BalanceMixin.prototype.showText = function (currency) {
        if (this.isDesktop || this.fullscreen) {
            return true;
        }
        else if (this.isLandscape) {
            return !this.gameplay;
        }
        else {
            return this.isMobile ? currency === this.activeCurrency : true;
        }
    };
    Object.defineProperty(BalanceMixin.prototype, "tooltipPosition", {
        get: function () {
            if (this.isDesktop && !this.gameplay) {
                return 'right';
            }
            else if (this.isDesktop && this.gameplay) {
                return 'bottom';
            }
            else if (this.isLandscape && this.gameplay) {
                return this.fullscreen ? 'bottom' : 'right';
            }
            else {
                return 'bottom';
            }
        },
        enumerable: false,
        configurable: true
    });
    BalanceMixin.prototype.formatIfOverLimit = function (balance) {
        return balance >= this.formatLimit
            ? exports.compactFormatter.format(balance)
            : exports.roundDownFormatter.format(balance);
    };
    BalanceMixin.prototype.onFullscreenChange = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.isTooltipOpen = false;
                return [2 /*return*/];
            });
        });
    };
    BalanceMixin.prototype.destroyed = function () {
        var _a, _b;
        (_a = this.deviceSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        (_b = this.landscapeSubscription) === null || _b === void 0 ? void 0 : _b.unsubscribe();
    };
    tslib_1.__decorate([
        services_1.FeatureEnabledV2({
            slug: magic_messages_1.Feature.TOP_NAVIGATION,
        })
    ], BalanceMixin.prototype, "isTopNavEnabled", void 0);
    tslib_1.__decorate([
        vue_property_decorator_1.Watch('fullscreen')
    ], BalanceMixin.prototype, "onFullscreenChange", null);
    BalanceMixin = tslib_1.__decorate([
        vue_property_decorator_1.Component
    ], BalanceMixin);
    return BalanceMixin;
}(vue_property_decorator_1.Vue));
exports.BalanceMixin = BalanceMixin;
